module.exports = __webpack_public_path__ + "static/media/customDesignExampleSmall1.ad5eb121.png";